
import geraData, { converterDataApiParaLocal } from '@/utils/geradata';

export default function dadosTabelas() {
  /* 
  nomeapi: => { opcional } NOME DA TABELA NA API,
  campoatt: => CAMPO PARA UTILIZAR NA HORA DA ATUALIZACAO,
  prefixo: => PREFIXO DA TABELA LOCAL,
  model =>  MODEL DO BANCO LOCAL,
  */
  return {
    produto: {
      campoatt: 'prodataalteracao',
      prefixo: 'pro',
      idapi: 'IdCortamanhoFinal',
      model: produto
    },
    grupo: {
      campoatt: 'grudataalteracao',
      prefixo: 'gru',
      idapi: 'idgrupo',
      model: grupo
    },
    categoria: {
      campoatt: 'catdataalteracao',
      prefixo: 'cat',
      idapi: 'IdCategoria',
      model: categoria
    },
    cor: {
      campoatt: 'cordataalteracao',
      prefixo: 'cor',
      idapi: 'idcor',
      model: cor
    },
    marcaveiculo: {
      campoatt: 'mavdataalteracao',
      prefixo: 'mav',
      idapi: 'IDMARCAVEIUCULO',
      model: marcaveiculo
    },
    veiculo: {
      campoatt: 'veidataalteracao',
      prefixo: 'vei',
      idapi: 'IDVEICULO',
      model: veiculo
    },
    cliente: {
      campoatt: 'clidataalteracao',
      prefixo: 'cli',
      idapi: 'IdCliente',
      model: cliente
    },
    vendedor: {
      campoatt: 'vendataalteracao',
      prefixo: 'ven',
      idapi: 'IdVendedor',
      model: vendedor
    },
    fornecedor: {
      campoatt: 'fordataalteracao',
      prefixo: 'for',
      idapi: 'idfornecedor',
      model: fornecedor
    },
    ordemservico: {
      campoatt: 'orsdataalteracao',
      prefixo: 'ors',
      idapi: 'IDORDEMSERVICO',
      model: ordemservico
    },
    ordemservicoitem: {
      campoatt: 'osidataalteracao',
      prefixo: 'osi',
      model: ordemservicoitem
    },
    prestacaoservico: {
      campoatt: 'prsdataalteracao',
      prefixo: 'prs',
      idapi: 'IDORDEMSERVICO',
      model: prestacaoservico
    },
    prestacaoservicoitem: {
      campoatt: 'pridataalteracao',
      prefixo: 'pri',
      idapi: 'IDITEMORDEMSERVICO',
      model: prestacaoservicoitem
    },
    empresa: {
      campoatt: 'empdataalteracao',
      prefixo: 'emp',
      idapi: 'idempresa',
      model: empresa
    },
  }
}

function getVal(item, ...aliases) {
  if (!item || typeof item !== 'object') return null;
  const flatAliases = aliases.flat(Infinity);
  for (const alias of flatAliases) {
    if (typeof alias === 'string' && item[alias] !== undefined && item[alias] !== null) {
      return item[alias];
    }
  }
  const keys = Object.keys(item);
  for (const alias of flatAliases) {
    if (typeof alias !== 'string') continue;
    const lowerAlias = alias.toLowerCase();
    const match = keys.find((k) => k.toLowerCase() === lowerAlias);
    if (match && item[match] !== undefined && item[match] !== null) {
      return item[match];
    }
  }
  return null;
}

export function empresa(item) {
  if (!item) return {};

  const idEmp = getVal(item, 'empidnuvem', 'empidempresa', 'ID_Empresa', 'IdEmpresa', 'idempresa', 'id');
  const nomeEmp = getVal(item, 'empnomeempresa', 'empNM_Empresa', 'empNomeEmpresa', 'NomeEmpresa', 'NM_Empresa', 'nomeempresa', 'nome', 'empresa');
  const nomeFan = getVal(item, 'empnomefantasia', 'empNomeFantasia', 'NomeFantasia', 'nomefantasia', 'fantasia');
  const cnpj = getVal(item, 'empcnpj', 'empCnpj', 'Cnpj', 'cnpj', 'CNPJ', 'cnpj_cpf');

  const cep = getVal(item, 'empcep', 'cep', 'Cep', 'CEP');
  const caminhoimagemduplicata = getVal(item, 'empcaminhoimagemduplicata', 'CaminhoImagemDuplicata', 'caminhoimagemduplicata');
  const cidadeuf = getVal(item, 'empcidadeuf', 'CidadeUF', 'cidadeuf');
  const datacargaitenstablet = getVal(item, 'empdatacargaitenstablet', 'DataCargaItensTablet', 'datacargaitenstablet');
  const chaveappvenda = getVal(item, 'empchaveappvenda', 'EMPChaveAppVenda', 'chaveappvenda', 'EMPCHAVEAPPVENDA');
  const diascargaitenstablet = getVal(item, 'empdiascargaitenstablet', 'EMPDiasCargaItensTablet', 'diascargaitenstablet');
  const imprimeprecoliquidoextratopedido = getVal(item, 'empimprimeprecoliquidoextratopedido', 'EMPImprimePrecoLiquidoExtratoPedido', 'imprimeprecoliquidoextratopedido');
  const email = getVal(item, 'empemail', 'email', 'Email', 'EMAIL');
  const endereco = getVal(item, 'empendereco', 'Endereco', 'endereco', 'ENDERECO');
  const enderecocompleto = getVal(item, 'empenderecocompleto', 'EnderecoCompleto', 'enderecocompleto');
  const hostsmtpnfe = getVal(item, 'emphostsmtpnfe', 'HostSmtpNfe', 'hostsmtpnfe');
  const impressorapadraoreciboentregaprodutopedidovenda = getVal(item, 'empimpressorapadraoreciboentregaprodutopedidovenda', 'ImpressoraPadraoReciboEntregaProdutoPedidoVenda', 'impressorapadraoreciboentregaprodutopedidovenda');
  const imprimedecimaisqtdepedidovenda = getVal(item, 'empimprimedecimaisqtdepedidovenda', 'ImprimeDecimaisQtdePedidoVenda', 'imprimedecimaisqtdepedidovenda');
  const inscricaoestadual = getVal(item, 'empinscricaoestadual', 'InscricaoEstadual', 'inscricaoestadual');
  const nm_bairro = getVal(item, 'empnm_bairro', 'NM_Bairro', 'nm_bairro', 'bairro', 'Bairro');
  const nm_cidade = getVal(item, 'empnm_cidade', 'NM_Cidade', 'nm_cidade', 'cidade', 'Cidade');
  const nomelivre1os = getVal(item, 'empnomelivre1os', 'NomeLivre1OS', 'nomelivre1os', 'NOMELIVRE1OS');
  const nomelivre2os = getVal(item, 'empnomelivre2os', 'NomeLivre2OS', 'nomelivre2os', 'NOMELIVRE2OS');
  const nomelivre3os = getVal(item, 'empnomelivre3os', 'NomeLivre3OS', 'nomelivre3os', 'NOMELIVRE3OS');
  const ospededadosequipamento = getVal(item, 'empospededadosequipamento', 'OSPedeDadosEquipamento', 'ospededadosequipamento', 'OSPEDEDADOSEQUIPAMENTO');
  const pedircodigoproduto = getVal(item, 'emppedircodigoproduto', 'PedirCodigoProduto', 'pedircodigoproduto');
  const portasmtpnfe = getVal(item, 'empportasmtpnfe', 'PortaSmtpNfe', 'portasmtpnfe');
  const senhasmtpnfe = getVal(item, 'empsenhasmtpnfe', 'SenhaSmtpNfe', 'senhasmtpnfe');
  const tp_empresa = getVal(item, 'emptp_empresa', 'TP_Empresa', 'tp_empresa');
  const telefone = getVal(item, 'emptelefone', 'telefone', 'Telefone', 'TELEFONE');
  const uf = getVal(item, 'empuf', 'UF', 'uf');
  const confirmavendaprodutozerado = getVal(item, 'empconfirmavendaprodutozerado', 'confirmavendaprodutozerado');
  const vendaprodutozerado = getVal(item, 'empvendaprodutozerado', 'vendaprodutozerado');
  const ospedetecnicoverificacao = getVal(item, 'empospedetecnicoverificacao', 'OSPedeTecnicoVerificacao', 'ospedetecnicoverificacao');
  const pedetecfechaos = getVal(item, 'emppedetecfechaos', 'PedeTecFechaOS', 'pedetecfechaos');
  const pedetecnicoitemos = getVal(item, 'emppedetecnicoitemos', 'PedeTecnicoItemOS', 'pedetecnicoitemos');
  const pedevaloracrescimoprevenda = getVal(item, 'emppedevaloracrescimoprevenda', 'PEDEVALORACRESCIMOPREVENDA', 'pedevaloracrescimoprevenda');
  const pedetecnicoretiroupeca = getVal(item, 'emppedetecnicoretiroupeca', 'PedeTecnicoRetirouPeca');
  const pedevalortecnicoitemos = getVal(item, 'emppedevalortecnicoitemos', 'PedeValorTecnicoItemOS');
  const qtdetecnicosos = getVal(item, 'empqtdetecnicosos', 'QtdeTecnicosOS');
  const dataalteracao = getVal(item, 'empdataalteracao', 'DataAlteracao', 'dataalteracao');

  return {
    empidnuvem: idEmp,
    empidempresa: idEmp,
    empnomeempresa: nomeEmp,
    empnomefantasia: nomeFan,
    empcnpj: cnpj,

    empcep: cep,
    empcaminhoimagemduplicata: caminhoimagemduplicata,
    empcidadeuf: cidadeuf,
    empdatacargaitenstablet: datacargaitenstablet,
    empchaveappvenda: chaveappvenda,
    empdiascargaitenstablet: diascargaitenstablet,
    empimprimeprecoliquidoextratopedido: imprimeprecoliquidoextratopedido,
    empemail: email,
    empendereco: endereco,
    empenderecocompleto: enderecocompleto,
    emphostsmtpnfe: hostsmtpnfe,
    empimpressorapadraoreciboentregaprodutopedidovenda: impressorapadraoreciboentregaprodutopedidovenda,
    empimprimedecimaisqtdepedidovenda: imprimedecimaisqtdepedidovenda,
    empinscricaoestadual: inscricaoestadual,
    empnm_bairro: nm_bairro,
    empnm_cidade: nm_cidade,
    empnomelivre1os: nomelivre1os,
    empnomelivre2os: nomelivre2os,
    empnomelivre3os: nomelivre3os,
    empospededadosequipamento: ospededadosequipamento,
    emppedircodigoproduto: pedircodigoproduto,
    empportasmtpnfe: portasmtpnfe,
    empsenhasmtpnfe: senhasmtpnfe,
    emptp_empresa: tp_empresa,
    emptelefone: telefone,
    empuf: uf,
    empconfirmavendaprodutozerado: confirmavendaprodutozerado,
    empvendaprodutozerado: vendaprodutozerado,

    empospedetecnicoverificacao: ospedetecnicoverificacao,
    emppedetecfechaos: pedetecfechaos,
    emppedetecnicoitemos: pedetecnicoitemos,
    emppedevaloracrescimoprevenda: pedevaloracrescimoprevenda,
    emppedetecnicoretiroupeca: pedetecnicoretiroupeca,
    empqtdetecnicosos: qtdetecnicosos,
    emppedevalortecnicoitemos: pedevalortecnicoitemos,

    empdataalteracao: dataalteracao,
  };
}


export function produto(item) {
    return {
      proidnuvem: item.IdCortamanhoFinal ?? null,
      proidcortamanhofinal: item.IdCortamanhoFinal ?? null,
      prodataalteracao: item.CTFDataAlteracao ?? null,
      prodescricao: item.descricao ?? item.Descricao ?? null,
      proidproduto: item.idproduto ?? item.IdProduto ?? null,
      provalor: item.valor ?? null,
      procodigointerno: item.CodigoInterno ?? item.codigointerno ?? null,
      proean: item.ean ?? item.EAN01 ?? item.ean01 ?? null,
      proidcategoriaproduto: item.idcategoriaproduto ?? item.idcategoriaproduto ?? item.idcategoriaproduto ?? null,
      proidgrupo: item.idgrupo ?? item.IdGrupo ?? null,
      proreferencia: item.referencia ?? null,
      grudescricao: item.grudescricao ?? item.Grupo ?? item.grupo ?? null,
    }
}

export function grupo(item) {
    return {
      grudataalteracao: item.dataalteracao,
      gruidnuvem: item.idgrupo,
      gruidgrupo: item.idgrupo,
      grudescricao: item.descricao,
    }
}

export function categoria(item) {
    return {
      catdataalteracao: item.DataCadastro,
      catidcategoria: item.IDCategoria,
      catdescricao: item.Descricao,
      catstatus: item.ativa,
      catservico: item.servico,
    }
}

export function cor(item) {
    return {
      coridnuvem: item.idcor,
      cordataalteracao: item.datacadastro,
      coridcor: item.idcor,
      cordescricao: item.descricao,
    }
}

export function marcaveiculo(item) {
    return {
      mavidnuvem: item.IDMARCAVEICULO ?? null,
      mavdataalteracao: item.DataAlteracao ?? null,
      mavidmarcaveiculo: item.IDMARCAVEICULO ?? null,
      mavdescricao: item.DESCRICAO ?? null,
    }
}

export function cliente(item) {
    return {
      cliidnuvem: item.IdCliente,
      clidataalteracao: item.DataAlteracao,
      cliidcliente: item.IdCliente,
      clinome: item.Nome,
      clicpf: item.CNPJ_CPF,
      clinomefantasia: item.Fantasia,
      cliendereco: item.Endereco,
      clicidade: item.Cidade,
      clibairro: item.Bairro,
      cliuf: item.UF,
      clicep: item.Cep,
      cliinscricaoestadual: item.InscricaoEstadual,
      clifone: item.Fone,
      cliemail: item.Email,
      clibloqueado: item.Bloqueado,
      clirestricao: item.Restricao,
      clilimitecredito: item.LimiteCredito,
      cliprivda: item.PriVDA,
      cliqtdevda: item.qtdeVDA,
      cliultvda: item.UltVDA,
      cliidforma: item.Idforma,
      cliidplanopagto: item.IdPlanoPagto,
      cliidvendedor: item.IdVendedor,
    }
}

  export function vendedor(item) {
    return {
      venidnuvem: item.IdVendedor,
      vennome: item.NomeVendedor,
      vencpf: item.CPF,
      vencodigo: item.Codigo,
      vendataalteracao: item.VENDaTaAlteracao,
    }
}

  export function fornecedor(item) {
    return {
      foridnuvem: item.idfornecedor,
      fornome: item.nome,
      fortelefone: item.telefone,
      forfantasia: item.fantasia,
      fortipopessoa: item.tipopessoa,
      forendereco: item.endereco,
      forcnpj_cpf: item.cpf,
      fortipo: item.TIPO,
      fordataalteracao: item.FORDataAlteracao,
    }
}

export function ordemservico(item) {
    return {
      orsidnuvem: item.IDORDEMSERVICO,
      orsdataalteracao: item.ORSDataAlteracao,
      orsidempresa: item.IDEMPRESA,
      orsobservacao: item.DEFEITO,
      orsidcliente: item.IDCLIENTE,
      orsdatacadastro: item.DATACADASTRO,
      orsidusuariorecebeu: item.IDRECEBIDO,
      orsdatafechamento: item.ORSDataInclusaoFechamento,
      orsstatus: item.STATUS,
      orsidvendedor: item.IdVendedorServico,
      orsidusuariocadastro: item.ORSIdUsuarioCadastro,
    }
}

export function ordemservicoitem(item) {
    return {  
      osidataalteracao: item.IOS,
      osiidproduto: item.IDPRODUTO,
      osidatainclusao: item.DataItem,
      osiobservacao: item.DescricaoComplementar,
      osiquantidade: item.QUANTIDADE,
      osiidusuario: item.IOSIdUsuarioCadastro,
      osivalorunitario: item.PRECOUNITARIO,
      osiidordemserviconuvem: item.IDORDEMSERVICO,
    }
}

export function veiculo(item) {
    return {  
      veiidnuvem: item.IDVEICULO,
      veidataalteracao: item.DataCadastro ?? item.veidataalteracao ?? null,
      veiidveiculo: item.IDVEICULO,
      veidescricao: item.DESCRICAO,
      veiplaca: item.PLACA,
      veiidcor: item.IDCOR,
      veicor: item.CorDescricao,
      veiidmarca: item.IDMARCA,
      veimarcanome: item.MarcaDescricao,
      veifrota: item.Frota,
      veicombustivel: item.COMBUSTIVEL,
      veiano: item.ANO,
      veianomodelo: item.ANOMODELO,
      veiidcliente: item.IDCLIENTE,
      veichassi: item.NroCHASSI,
      veinumeroserie: item.NUMEROSERIE,
      veiidcidade: item.IdCidade,
      veistatus: item.ativo,
    }
}

export function prestacaoservico(item) {
    const rawApiAlt = getVal(item, ['ORSDataAlteracao', 'ORSDataInclusao', 'DATACADASTRO']);
    const dataAlt = rawApiAlt ? converterDataApiParaLocal(rawApiAlt) : (item.prsdataalteracao || null);
    const rawApiInc = getVal(item, ['DATACADASTRO', 'ORSDataInclusao']);
    const dataInc = rawApiInc ? converterDataApiParaLocal(rawApiInc) : (item.prsdatainclusao || null);
    const rawApiFec = getVal(item, ['DATAFECHAMENTO']);
    const dataFec = rawApiFec ? converterDataApiParaLocal(rawApiFec) : (item.prsdatafechamento || null);
    const isFromCloud = Boolean(getVal(item, ['IDORDEMSERVICO', 'prsidnuvem']));
    return {
      prsidnuvem: getVal(item, ['IDORDEMSERVICO', 'prsidnuvem']),
      prsidprestacaoservico: getVal(item, ['IDORDEMSERVICO', 'prsidprestacaoservico']),
      prsidempresa: getVal(item, ['IDEMPRESA', 'prsidempresa']),
      prsidcliente: getVal(item, ['IDCLIENTE', 'prsidcliente']),
      prstipo: getVal(item, ['Tipo', 'prstipo']) ?? 1,
      prsidusuario: getVal(item, ['ORSIdUsuarioCadastro', 'prsidusuario']),
      prsidfornecedor: getVal(item, ['IdFornecedorIndicacao', 'prsidfornecedor']),
      prsidvendedor: getVal(item, ['IdVendedorServico', 'prsidvendedor']),
      prsrecebidopor: getVal(item, ['IDRECEBIDO', 'prsrecebidopor']),
      prsidtecnicoverificacao: getVal(item, ['IDTECNICOVERIFICACAO', 'IdTecnicoVerificacao', 'prsidtecnicoverificacao']),
      prsdatainclusao: dataInc,
      prsdefeito: getVal(item, ['DEFEITO', 'prsdefeito']),
      prsobservacao: getVal(item, ['OBSERVACAOEQUIPAMENTO', 'prsobservacao']),
      prsdatafechamento: dataFec,
      prsidvendedoralteracao: getVal(item, ['ORSIdUsuarioAlteracao', 'prsidvendedoralteracao']),
      prsnumeroserieequipamento: getVal(item, ['NUMEROSERIEEQUIPAMENTO', 'prsnumeroserieequipamento']),
      prsidveiculo: getVal(item, ['IDVEICULO', 'prsidveiculo']),
      prsidmarcaveiculo: getVal(item, ['IdMarcaVeiculo', 'prsidmarcaveiculo']),
      prskm: getVal(item, ['KM', 'prskm']),
      prsmotor: getVal(item, ['Motor', 'prsmotor']),
      prsanoveiculo: getVal(item, ['Ano', 'prsanoveiculo']),
      prsanomodeloveiculo: getVal(item, ['AnoModelo', 'prsanomodeloveiculo']),
      prscombustivel: getVal(item, ['Combustivel', 'prscombustivel']),
      prsnumerochassi: getVal(item, ['NroChassi', 'prsnumerochassi']),
      prsdescricaoequipamento: getVal(item, ['DESCRICAOEQUIPAMENTO', 'prsdescricaoequipamento']),
      prsmarcaequipamento: getVal(item, ['MARCAEQUIPAMENTO', 'prsmarcaequipamento']),
      prsidentificacaoidsequipamento: getVal(item, ['IDENTIFICACAOIDSEQUIPAMENTO', 'prsidentificacaoidsequipamento']),
      prsdadocomplementar: getVal(item, ['DadoComplementar', 'prsdadocomplementar']),
      prslivre1: getVal(item, ['Livre1', 'prslivre1']),
      prslivre2: getVal(item, ['Livre2', 'prslivre2']),
      prslivre3: getVal(item, ['Livre3', 'prslivre3']),
      prsdataalteracao: dataAlt,
      status: item.status || item.descricaostatus ,
      ...(isFromCloud ? { prsdatatransmissao: item.prsdatatransmissao || dataAlt || geraData() } : {}),
    }
}

export function prestacaoservicoitem(item) {
    const rawApiAlt = getVal(item, ['IOSDataAlteracao', 'DataItem']);
    const dataAlt = rawApiAlt ? converterDataApiParaLocal(rawApiAlt) : (item.pridataalteracao || null);
    const rawApiInc = getVal(item, ['DataItem']);
    const dataInc = rawApiInc ? converterDataApiParaLocal(rawApiInc) : (item.pridatainclusao || null);
    const isFromCloud = Boolean(getVal(item, ['IDITEMORDEMSERVICO', 'priidnuvem']));
    return {
      priidnuvem: getVal(item, ['IDITEMORDEMSERVICO', 'priidnuvem']),
      priidprestacaoserviconuvem: getVal(item, ['IDORDEMSERVICO', 'priidprestacaoserviconuvem']),
      priidproduto: getVal(item, ['IDPRODUTO', 'priidproduto']),
      pridescricao: getVal(item, ['DESCRICAOITEM', 'pridescricao']),
      priordem: getVal(item, ['item', 'priordem']),
      priquantidade: getVal(item, ['QUANTIDADE', 'priquantidade']),
      privalor: getVal(item, ['PRECOUNITARIO', 'privalor']),
      pridatainclusao: dataInc,
      priidusuario: getVal(item, ['IOSIdUsuarioCadastro', 'priidusuario']),
      pritecnico: getVal(item, ['IDTECNICO', 'pritecnico']),
      pritecnico2: getVal(item, ['IDTECNICO2', 'pritecnico2']),
      pritecnico3: getVal(item, ['IDTECNICO3', 'pritecnico3']),
      pritecnicoretiroupeca: getVal(item, ['IDTECNICORETIROUPECA', 'IdTecnicoRetirouPeca', 'pritecnicoretiroupeca']),
      privalortecnico: getVal(item, ['VALORTECNICO', 'privalortecnico']),
      privalortecnico2: getVal(item, ['VALORTECNICO2', 'privalortecnico2']),
      privalortecnico3: getVal(item, ['VALORTECNICO3', 'privalortecnico3']),
      priobservacao: getVal(item, ['DescricaoComplementar', 'priobservacao']),
      pridataalteracao: dataAlt,
      ...(isFromCloud ? { pridatatransmissao: item.pridatatransmissao || dataAlt || geraData() } : {}),
    }
}
